export default __webpack_public_path__ + "static/media/Yasmin_9781408309100.9a23bd04.jpg";